import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcNetworkSwitcher = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M12.751 11.2V3.5h-1.5v7.7a1.498 1.498 0 0 1 1.5 0Zm0 0a1.5 1.5 0 0 1 0 2.6l6.67 3.85.75-1.3-6.67-3.85 6.67-3.85-.75-1.3-6.67 3.85Zm0 2.6a1.495 1.495 0 0 1-1.5 0v7.7h1.5v-7.7Zm-1.5 0a1.5 1.5 0 0 1-.75-1.3l-6.669 3.85.75 1.3 6.669-3.85Zm-.75-1.3a1.5 1.5 0 0 1 .75-1.3L4.582 7.35l-.75 1.3 6.669 3.85Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M13.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM21 8.25a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-15 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm15 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-15 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm7.5 3.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm0-2a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcNetworkSwitcher");

export { IcNetworkSwitcher };
//# sourceMappingURL=ic-network-switcher.js.map
